import React from "react";

function PrivacyPolicy() {
  return (
    <div
      style={{
        background: "#fff",
        minHeight: "100vh",
        color: "#0f172a",
        paddingBottom: 80,
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "80px 20px 0",
        }}
      >
        <section
          style={{
            background: "#fff",
            borderRadius: 32,
            padding: "60px 40px",
            boxShadow: "0 30px 90px rgba(15,23,42,0.15)",
            position: "relative",
            overflow: "hidden",
            border: "1px solid rgba(226,232,240,0.5)",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: 240,
              height: 240,
              borderRadius: "50%",
              background: "rgba(148, 163, 255, 0.15)",
              top: -60,
              right: -60,
              filter: "blur(10px)",
            }}
          />
          <div style={{ position: "relative", zIndex: 2 }}>
            <p
              style={{
                letterSpacing: 4,
                textTransform: "uppercase",
                color: "#4f46e5",
                fontWeight: 600,
                fontSize: 14,
                marginBottom: 8,
              }}
            >
              Privacy Policy
            </p>
            <h1
              style={{
                fontSize: 48,
                fontWeight: 900,
                margin: "10px 0 16px",
                color: "#0f172a",
              }}
            >
              EventNova Privacy Policy
            </h1>
            <p
              style={{
                fontSize: 16,
                color: "#64748b",
                marginTop: 8,
              }}
            >
              Last Updated: 20/11/2025
            </p>
            <p
              style={{
                fontSize: 18,
                color: "#1e293b",
                maxWidth: 720,
                lineHeight: 1.8,
                marginTop: 20,
              }}
            >
              EventNova ("we," "our," or "the Platform") is committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, store, and safeguard data when you access or use the EventNova platform.
            </p>
            <p
              style={{
                fontSize: 18,
                color: "#1e293b",
                maxWidth: 720,
                lineHeight: 1.8,
                marginTop: 16,
              }}
            >
              By using EventNova, you agree to the practices described in this Policy. If you do not agree, please discontinue use of the Platform.
            </p>
          </div>
        </section>

        <section style={{ marginTop: 60 }}>
          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Information We Collect
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 20,
              }}
            >
              We collect the following categories of information:
            </p>

            <h3
              style={{
                fontSize: 20,
                marginTop: 24,
                marginBottom: 12,
                color: "#0f172a",
                fontWeight: 700,
              }}
            >
              Personal Information Provided by Vendors
            </h3>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 12,
              }}
            >
              When vendors create accounts or subscribe to services, we may collect:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Full name and business name</li>
              <li style={{ marginBottom: 8 }}>Email address and phone number</li>
              <li style={{ marginBottom: 8 }}>Business category and service details</li>
              <li style={{ marginBottom: 8 }}>Images, videos, or promotional materials uploaded</li>
              <li style={{ marginBottom: 8 }}>Billing information for subscriptions or ads</li>
              <li style={{ marginBottom: 8 }}>Any other details provided to complete a vendor profile</li>
            </ul>

            <h3
              style={{
                fontSize: 20,
                marginTop: 28,
                marginBottom: 12,
                color: "#0f172a",
                fontWeight: 700,
              }}
            >
              User Information (Non-Vendor)
            </h3>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 12,
              }}
            >
              For general platform visitors, we may collect:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Name and email (if contact forms are used)</li>
              <li style={{ marginBottom: 8 }}>Search interactions and vendor views</li>
              <li style={{ marginBottom: 8 }}>Device and browser information</li>
              <li style={{ marginBottom: 8 }}>IP address and location (approximate)</li>
            </ul>

            <h3
              style={{
                fontSize: 20,
                marginTop: 28,
                marginBottom: 12,
                color: "#0f172a",
                fontWeight: 700,
              }}
            >
              Automatically Collected Data
            </h3>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 12,
              }}
            >
              Through analytics and cookies, we may collect:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Device identifiers</li>
              <li style={{ marginBottom: 8 }}>Usage patterns</li>
              <li style={{ marginBottom: 8 }}>Clickstream data</li>
              <li style={{ marginBottom: 8 }}>Advertisement interactions</li>
              <li style={{ marginBottom: 8 }}>Website performance metrics</li>
            </ul>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 16,
                padding: 16,
                background: "#f1f5f9",
                borderRadius: 12,
              }}
            >
              <strong>Note:</strong> EventNova does not collect or store payment card numbers. All subscription payments are processed securely through third-party payment gateways.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              How We Use Your Information
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 16,
              }}
            >
              EventNova uses collected data to:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Create and manage user and vendor accounts</li>
              <li style={{ marginBottom: 8 }}>Display vendor profiles publicly on the platform</li>
              <li style={{ marginBottom: 8 }}>Process subscription and advertising payments</li>
              <li style={{ marginBottom: 8 }}>Improve platform functionality, speed, and performance</li>
              <li style={{ marginBottom: 8 }}>Communicate important updates, notifications, and support messages</li>
              <li style={{ marginBottom: 8 }}>Enforce Terms & Conditions and prevent fraudulent activity</li>
              <li style={{ marginBottom: 8 }}>Analyze platform usage to enhance user experience</li>
              <li style={{ marginBottom: 8 }}>Customize vendor visibility, ads, and promotional options</li>
            </ul>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 16,
                fontWeight: 600,
              }}
            >
              We do not sell personal information to third parties.
            </p>

            <h3
              style={{
                fontSize: 20,
                marginTop: 28,
                marginBottom: 12,
                color: "#0f172a",
                fontWeight: 700,
              }}
            >
              Legal Basis for Processing (Where Applicable)
            </h3>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 12,
              }}
            >
              We process personal information based on:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}><strong>Consent:</strong> When users voluntarily provide information.</li>
              <li style={{ marginBottom: 8 }}><strong>Contract:</strong> To deliver services vendors subscribe to.</li>
              <li style={{ marginBottom: 8 }}><strong>Legitimate Interest:</strong> To maintain platform security and functionality.</li>
              <li style={{ marginBottom: 8 }}><strong>Compliance With Law:</strong> When required for legal or regulatory purposes.</li>
            </ul>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Information Sharing & Disclosure
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 20,
              }}
            >
              EventNova may share limited data only under the following conditions:
            </p>

            <h3
              style={{
                fontSize: 20,
                marginTop: 24,
                marginBottom: 12,
                color: "#0f172a",
                fontWeight: 700,
              }}
            >
              With Service Providers
            </h3>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 12,
              }}
            >
              Third-party companies that assist with:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Payment processing</li>
              <li style={{ marginBottom: 8 }}>Email delivery</li>
              <li style={{ marginBottom: 8 }}>Data analytics</li>
              <li style={{ marginBottom: 8 }}>Advertising management</li>
              <li style={{ marginBottom: 8 }}>Cloud hosting</li>
            </ul>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 12,
              }}
            >
              These partners are forbidden from using your information for anything other than providing services to EventNova.
            </p>

            <h3
              style={{
                fontSize: 20,
                marginTop: 28,
                marginBottom: 12,
                color: "#0f172a",
                fontWeight: 700,
              }}
            >
              Legal Requirements
            </h3>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 12,
              }}
            >
              We may disclose information if required to:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Comply with legal obligations</li>
              <li style={{ marginBottom: 8 }}>Respond to valid requests from law enforcement</li>
              <li style={{ marginBottom: 8 }}>Protect the rights and safety of EventNova and users</li>
            </ul>

            <h3
              style={{
                fontSize: 20,
                marginTop: 28,
                marginBottom: 12,
                color: "#0f172a",
                fontWeight: 700,
              }}
            >
              Vendor Profile Visibility
            </h3>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
              }}
            >
              Vendor business information uploaded voluntarily (e.g., profile details, images, descriptions) will be publicly visible on the platform as part of service delivery.
            </p>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 12,
              }}
            >
              EventNova does not share private personal information with customers or external parties.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Data Security
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 16,
              }}
            >
              We implement strict administrative, technical, and physical safeguards to protect your information, including:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Encrypted data transmission</li>
              <li style={{ marginBottom: 8 }}>Secure payment systems</li>
              <li style={{ marginBottom: 8 }}>Restricted access to administrative tools</li>
              <li style={{ marginBottom: 8 }}>Firewalls and intrusion detection systems</li>
              <li style={{ marginBottom: 8 }}>Regular platform monitoring</li>
            </ul>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 16,
              }}
            >
              Although no system is 100% secure, EventNova takes all reasonable measures to protect user data from unauthorized access or misuse.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Data Retention
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
              }}
            >
              We retain personal data only for as long as necessary for:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8, marginTop: 12 }}>
              <li style={{ marginBottom: 8 }}>Providing platform services</li>
              <li style={{ marginBottom: 8 }}>Maintaining vendor profiles</li>
              <li style={{ marginBottom: 8 }}>Meeting legal and regulatory obligations</li>
            </ul>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 16,
              }}
            >
              Vendors may request account deletion; however, EventNova may retain certain data for fraud prevention, financial audit purposes, or lawful compliance.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Cookies & Tracking Technologies
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 16,
              }}
            >
              EventNova uses cookies and similar tools to:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Personalize user experience</li>
              <li style={{ marginBottom: 8 }}>Track site performance</li>
              <li style={{ marginBottom: 8 }}>Store vendor login sessions</li>
              <li style={{ marginBottom: 8 }}>Optimize advertising placements</li>
            </ul>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 16,
              }}
            >
              Users may disable cookies through their browser, but this may affect platform functionality.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Vendor Responsibilities
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 16,
              }}
            >
              Vendors using EventNova agree to:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Provide accurate business information</li>
              <li style={{ marginBottom: 8 }}>Not upload content violating intellectual property rights</li>
              <li style={{ marginBottom: 8 }}>Protect their account login details</li>
              <li style={{ marginBottom: 8 }}>Comply with EventNova's Terms & Conditions</li>
              <li style={{ marginBottom: 8 }}>Avoid posting personal data of clients without consent</li>
            </ul>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Third-Party Links
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
              }}
            >
              EventNova may display links to external sites or vendor pages. We are not responsible for the privacy practices of third-party websites or services.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Children's Privacy
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
              }}
            >
              EventNova is not intended for children under 16. We do not knowingly collect data from minors.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Refund-Related Data Handling
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 16,
              }}
            >
              To align with EventNova's Refund Policy:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>All billing data is stored securely</li>
              <li style={{ marginBottom: 8 }}>Refund requests (if eligible under exceptional cases) may require verification details</li>
              <li style={{ marginBottom: 8 }}>No payment card information is stored by EventNova</li>
              <li style={{ marginBottom: 8 }}>All financial interactions follow secure gateway protocols</li>
            </ul>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 16,
              }}
            >
              EventNova only processes information necessary for subscription validation and fraud prevention.
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Your Privacy Rights
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginBottom: 16,
              }}
            >
              Depending on your jurisdiction, you may have the right to:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20, color: "#1e293b", lineHeight: 1.8 }}>
              <li style={{ marginBottom: 8 }}>Access your personal information</li>
              <li style={{ marginBottom: 8 }}>Request corrections or updates</li>
              <li style={{ marginBottom: 8 }}>Request deletion (where legally permissible)</li>
              <li style={{ marginBottom: 8 }}>Withdraw consent</li>
              <li style={{ marginBottom: 8 }}>Restrict processing</li>
              <li style={{ marginBottom: 8 }}>Request portability of your data</li>
            </ul>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
                marginTop: 16,
              }}
            >
              To make a request, contact:{" "}
              <a
                href="mailto:info@eventnova.com.ng"
                style={{ color: "#4f46e5", textDecoration: "underline" }}
              >
                info@eventnova.com.ng
              </a>
            </p>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.8)",
              boxShadow: "0 18px 60px rgba(15,23,42,0.08)",
              marginBottom: 32,
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Changes to This Privacy Policy
            </h2>
            <p
              style={{
                fontSize: 16,
                color: "#1e293b",
                lineHeight: 1.8,
              }}
            >
              EventNova may update this Policy periodically. Changes take effect upon posting. Continued use of the platform indicates acceptance of modified terms.
            </p>
          </div>

          <section
            style={{
              marginTop: 50,
              background: "#fff",
              borderRadius: 24,
              padding: 40,
              border: "1px solid rgba(226,232,240,0.9)",
              boxShadow: "0 20px 60px rgba(15,23,42,0.08)",
            }}
          >
            <h2
              style={{
                fontSize: 28,
                marginBottom: 24,
                color: "#0f172a",
                fontWeight: 800,
              }}
            >
              Contact Information
            </h2>
            <p style={{ color: "#1f2937", lineHeight: 1.8, marginBottom: 0 }}>
              For questions or privacy-related concerns, contact:{" "}
              <a
                href="mailto:info@eventnova.com.ng"
                style={{ color: "#4f46e5", textDecoration: "underline" }}
              >
                info@eventnova.com.ng
              </a>
            </p>
          </section>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
